export default "/profile/images/viber_btn.svg?9e86bebfd7bc36e25722a05c4032274a";